export default {
  subscription: 'kuiuanchorage',
  mailing_list: 39,
  info_url: 'http://kuiubeerproject.com/',
  title: {
    in_progress: '#KUIUBEERPROJECT',
    success: "YOU'RE ALMOST DONE!",
    subtext: 'Sign-up to get exclusive access to Verde 2.0 IPA and Goliath Imperial Stout',
  },
  cancel_anytime: null,
  review: {
    agreement: null,
    title: 'Add me!',
    summary: [
      "By being on the list, you'll get exclusive access to Verde 2.0 IPA and Goliath Imperial Stout on Tavour's APP!",
    ],
    button_text: 'Add me to list!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/kuiuanchorage.js